{
    "AddNotification": "Aggiungi notifica",
    "EditNotification": "Modifica della notifica",
    "EnableNotification": "Abilita la notifica",
    "DisableNotification": "Disattivare la notifica",
    "NotificationNameBusyTime": "Tempo di lavoro",
    "NotificationNameAvgAnswerTime": "Tempo medio di risposta (secondi)",
    "NotificationNameUserNotLoggedIn7Days": "Utente non connesso da 7 giorni",
    "NotificationNameMissedCalls": "Chiamate perse (#)",
    "NotificationNameUserNeverLoggedIn": "Mai registrato",
    "NotificationNameWeeklyInsightsReport": "Rapporto settimanale sugli approfondimenti",
    "NAME": "NotificationsLanguage"
}